import React, { useMemo } from 'react';
import { hasTextField, parseSellingRationaleParagraphs } from '@/lib/accountFinancials';

export default function SellingRationaleSection({ sellingRationale }) {
  const paragraphs = useMemo(
    () => parseSellingRationaleParagraphs(sellingRationale),
    [sellingRationale],
  );

  if (!paragraphs.length) return null;

  return (
    <aside className="mb-5 max-w-2xl rounded-lg border border-gray-200 bg-gray-50/80 px-4 py-3">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-[#5C6B7A] mb-2">
        Why it&apos;s for sale
      </p>
      <div className="space-y-2">
        {paragraphs.map((paragraph, index) => {
          const isSourceFootnote =
            index === paragraphs.length - 1 && /^source:/i.test(paragraph);

          if (isSourceFootnote) {
            return (
              <p key={index} className="text-[11px] text-[#5C6B7A]/80 leading-relaxed pt-1">
                {paragraph}
              </p>
            );
          }

          return (
            <p key={index} className="text-xs text-[#5C6B7A] leading-relaxed">
              {paragraph}
            </p>
          );
        })}
      </div>
    </aside>
  );
}
